import {IJournal} from "@/types/journal.types";
import Link from "next/link";
import React from "react";

const InspirationCard: React.FC<{data: IJournal}> = ({data}) => {
  return (
    <div className="group">
      <Link href={"/inspiration/" + data.slug}>
        <img className="w-full aspect-square" src={data.thumbnail} alt={data.title} />
      </Link>
      <div className="text-center ">
        <span className="block mt-2 text-gray-base">{data.category.name}</span>
        <Link href={"/inspiration/" + data.slug}>
          <p className="w-10/12 mx-auto mt-2 group-hover:font-medium">{data.title}</p>
        </Link>
        <Link className="underline group-hover:no-underline text-blue-base" href={"/inspiration/" + data.slug}>
          Read More
        </Link>
      </div>
    </div>
  );
};

export default InspirationCard;
